module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_2.d02253f1.png";